import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import type { RestaurantStatus } from '@garlic/shared';
import { PublicMenuPage } from './public/PublicMenuPage';
import { JoinTable } from './public/JoinTable';
import { MyTable } from './public/MyTable';
import { PayBill } from './public/PayBill';
import { ExitReceipt } from './public/ExitReceipt';
import { StaffLogin, ForgotPassword, SetPassword } from './StaffAuth';
import { StaffApp } from './StaffApp';

export type TenantRestaurant = {
  name: string; slug: string; status: RestaurantStatus; timezone: string;
  primaryColor: string; accentColor: string; logoPath: string | null; coverPath: string | null;
};
export type TenantContext = { kind: 'tenant'; restaurant: TenantRestaurant };

/** Contraste mínimo: texto branco em cores escuras, tinta em cores claras. */
function contrastFor(hex: string) {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return lum > 0.45 ? '#1f1a17' : '#ffffff';
}

export function TenantApp({ ctx }: { ctx: TenantContext }) {
  const r = ctx.restaurant;
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--brand', r.primaryColor);
    root.style.setProperty('--brand-contrast', contrastFor(r.primaryColor));
    document.title = r.name;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', r.primaryColor);
  }, [r]);

  return (
    <Routes>
      {/* Clientes: garlicfood.com.br/r/{slug}/... */}
      <Route path="/r/:slug/mesa/:mesa" element={<JoinTable restaurant={r} />} />
      <Route path="/r/:slug/mesa" element={<MyTable restaurant={r} />} />
      <Route path="/r/:slug/conta" element={<PayBill restaurant={r} />} />
      <Route path="/r/:slug/saida" element={<ExitReceipt restaurant={r} />} />
      <Route path="/r/:slug/*" element={<PublicMenuPage restaurant={r} />} />
      {/* Equipe: garlicfood.com.br/painel/{slug}/... */}
      <Route path="/painel/:slug/login" element={<StaffLogin restaurant={r} />} />
      <Route path="/painel/:slug/recuperar" element={<ForgotPassword restaurant={r} />} />
      <Route path="/painel/:slug/convite" element={<SetPassword restaurant={r} />} />
      <Route path="/painel/:slug/redefinir" element={<SetPassword restaurant={r} />} />
      <Route path="/painel/:slug/*" element={<StaffApp restaurant={r} />} />
    </Routes>
  );
}
